import {DateTime} from 'luxon';

/**
 * Updates <time> tags with a datetime attribute in ISO 8601 format to
 * display in the user's local time
 * @returns {void}
 */
const updateTimeTags = () => {
  const timeTags = document.querySelectorAll('time[datetime]');

  for (let i = 0; i < timeTags.length; i++) {
    const timeTag = timeTags[i];

    const timestamp = DateTime.fromISO(timeTag.getAttribute('datetime'), {
      zone: 'utc',
    });

    const localTimestamp = timestamp.toLocal();

    timeTag.textContent = localTimestamp.toLocaleString(DateTime.DATETIME_FULL);
  }
};

const updateDateTags = () => {
  const timeTags = document.querySelectorAll('time[date]');

  for (let i = 0; i < timeTags.length; i++) {
    const timeTag = timeTags[i];

    const timestamp = DateTime.fromISO(timeTag.getAttribute('date'), {
      zone: 'utc',
    });

    const localTimestamp = timestamp.toLocal();

    let returnStr = localTimestamp.toLocaleString(DateTime.DATETIME_FULL);

    returnStr = returnStr.split(',');
    returnStr.pop();
    returnStr = returnStr.join(',');

    timeTag.textContent = returnStr;
  }
};

const Table = {
  mounted() {
    updateTimeTags();
    updateDateTags();
  },
  updated() {
    updateTimeTags();
    updateDateTags();
  },
};

export {Table, updateDateTags, updateTimeTags};
